// import { set } from "date-fns";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import InputField from '../../../CommonComponents/InputMUI'
import SelectField from '../../../CommonComponents/SelectMUI'
import Alerts from "../../../Popups/SidePopup";
import Loader from "../../../../../../presentationals/Loader/Loader.component";
import { getCommission, getTimeSpent, saveCommission, startOrStopTimer, updateCommissionByLoanId,CommunityLeadGetUserLoanApi } from "../../CommunityActionCreator";

const commissionBy = [
    { code: 'LENDER', name: 'Lender' },
    { code: 'USER', name: 'User' }
]

const Commission = ({rowData}) => {

    const [allData, setAllData] = useState({})
    const [message, setMessage] = useState({})
    const location = useLocation()
    const [disable, setDisable] = useState(false)
    const [loaderState, setLoaderState] = useState(false)
    const [alertPopup, setalertPopup] = useState(false)
    const [msg, setmsg] = useState(false)
    const [timeSpent, setTimeSpent] = useState(0)
    const [totalTime, setTotalTime] = useState(0)


    const [communityExpectedCommision, setCommunityExpectedCommision] = useState('')



    useEffect(() => {
        if (rowData) {
            getData(rowData.loanId)
            getLoanDetail(rowData.loanId)
            getTotalTimeSpent(rowData.loanId, "days")
        }
    }, [])

    const getLoanDetail = (loanId) => {
        setLoaderState(true)
        CommunityLeadGetUserLoanApi(loanId,
            callBack => {
                if (callBack) {
                    setCommunityExpectedCommision(callBack.commissionValue)
                }
                setLoaderState(false)
            }, error => {
                setLoaderState(false)
            })
    }

    const getTotalTimeSpent = (loanId, type) => {
        getTimeSpent(loanId, type, callBack => {
            if (callBack) {
                setTimeSpent(callBack.data)
            } else {
                setTimeSpent(0)
            }
        }, error => {

        })
    }

    const startOrStopTime = (loanId, timer) => {
        startOrStopTimer(loanId, timer, callBack => {
            getData(loanId)
        }, error => {

        })
    }


    const saveHandler = (type) => {
        if (type === 'save') {
            setLoaderState(true)
            let valid = validations(allData)
            if (valid.status) {
                setMessage({})
                allData['loanId'] = rowData.loanId
                allData['lenderId'] = rowData.lenderId
                allData['userId'] = rowData.userId
                setAllData(allData)
                saveCommission(allData, callback => {
                    if (callback.message === "success") {
                        setAllData(callback.data)
                        setTotalTime(callback.data.turnAroundTime)
                        setDisable(true)
                        setalertPopup(true)
                        setmsg("Commision saved Successfully!")
                        removePopup()

                    }else{
                        setalertPopup(true)
                        setmsg("Something Went Wrong!")
                        removePopup()
                    }
                    setLoaderState(false)
                }, error => {

                })
            } else {
                setMessage(valid)
                setLoaderState(false)
            }
            setLoaderState(true)
            updateCommissionByLoanId(rowData.loanId,
                communityExpectedCommision, callback => {
                    setLoaderState(false)
                }, error => {
                    setLoaderState(false)
                })
        } else {
            setDisable(false)
        }
    }

    const getData = (loanId) => {
        getCommission(loanId, callback => {
            if (callback.message === 'success') {
                if (callback.data) {
                    setDisable(true)
                    setTotalTime(callback.data.turnAroundTime)
                    setAllData(callback.data)
                }
            }
        }, error => {

        })

    }
    const removePopup = () => {
        setTimeout(
            function () {
                setalertPopup(false)
            }.bind(this),
            5000
        );
    }

    const validations = (allData) => {
        if (allData.commissionByLender === '' || allData.commissionByLender === undefined) {
            return {
                status: false,
                msg: 'Please enter lender Commission Percentage',
                field: 'commissionByLenderHelp'
            }
        }
        if (allData.commissionByLender && allData.commissionByLender > 100) {
            return {
                status: false,
                msg: "Commission Percentage shouldn't be more than 100",
                field: 'commissionByLenderHelp'
            }
        }
        if (allData.commissionByUser === '' || allData.commissionByUser === undefined) {
            return {
                status: false,
                msg: 'Please enter User Commission Percentage',
                field: 'commissionByUserHelp'
            }
        }
        if (allData.commissionByUser && allData.commissionByUser > 100) {
            return {
                status: false,
                msg: "Commission Percentage shouldn't be more than 100",
                field: 'commissionByUserHelp'
            }
        }
        if (allData.turnAroundTime && allData.turnAroundTime === '' || allData.turnAroundTime === undefined) {
            return {
                status: false,
                msg: "Please Enter Turn Around time",
                field: 'turnAroundTimeHelp'
            }
        }
        return {
            status: true,
            msg: '',
            field: ''
        }

    }

    const inputChange = (e, type) => {
        if (type === 'communityExpectedCommision') {
            console.log(e);
            setCommunityExpectedCommision(e)
        } else {
            let changeObjectData = Object.assign({}, allData)
            changeObjectData[type] = e
            setAllData(changeObjectData)
            setMessage({})
        }
    }

    return (
        <div className='container-fluid mt-3'>
            {loaderState ?
                <Loader />
                : null}
            <div className="row">
                <div className='mb-3 col-sm-5 col-xs-12'>
                    <div style={{ marginBottom: "20px" }}>
                        {/* {
                            window.location.href.includes('lender/') ?
                                <h4 style={{ marginLeft: '12px' }}>Lender Commission</h4>
                                : window.location.href.includes('community/') ?
                                    <h4 style={{ marginLeft: '12px' }}>User Commission</h4>
                                    : window.location.href.includes('admin/') ?
                                        <h4 style={{ marginLeft: '12px' }}>Lender and User Commission</h4>
                                        : ""
                        } */}
                        <h4 style={{ marginLeft: '12px',fontSize:'24px',fontWeight:'400' }}>Lender and User Commission</h4>
                    </div>
                    {/* {window.location.href.includes('lender/') || window.location.href.includes('admin/') ? */}
                        <div>
                            <div className='mb-3 col-sm-12 col-xs-12'>
                                <InputField
                                    label="Lender Commission Percentage"
                                    variant="outlined"
                                    value={allData.commissionByLender}
                                    name="lenderCommissionPercentage"
                                    id="lenderCommissionPercentage"
                                    required={true}
                                    type="number"
                                    readOnly={disable}
                                    onChange={e => inputChange(e, 'commissionByLender')}
                                    size="small" />
                                <div id="commissionByLenderHelp" className="form-text text-danger">{message.field === 'commissionByLenderHelp' ? message.msg : ""}</div>
                            </div>

                            <div className='mb-3 col-sm-12 col-xs-12'>
                                <InputField
                                    label="Turn Around Days (working days)"
                                    variant="outlined"
                                    value={allData.turnAroundTime}
                                    name="turnAroundDays"
                                    id="turnAroundDays"
                                    required={true}
                                    type="number"
                                    readOnly={disable}
                                    onChange={e => inputChange(e, 'turnAroundTime')}
                                    size="small" />
                                <div id="turnAroundTimeHelp" className="form-text text-danger">{message.field === 'turnAroundTimeHelp' ? message.msg : ""}</div>
                            </div>
                        </div>
                        {/* : ""} */}
                    {/* {window.location.href.includes('community/') || window.location.href.includes('admin/') ? */}
                        <div className='mb-3 col-sm-12 col-xs-12'>
                            <InputField
                                label="User Commission Percentage"
                                variant="outlined"
                                value={allData.commissionByUser}
                                name="commissionByUser"
                                id="commissionByUser"
                                required={true}
                                type="number"
                                readOnly={allData && allData.commissionByUser ? disable : false}
                                onChange={e => inputChange(e, 'commissionByUser')}
                                size="small" />
                            <div id="commissionByUserHelp" className="form-text text-danger">{message.field === 'commissionByUserHelp' ? message.msg : ""}</div>
                        </div>
                         {/* : ""} */}
                    {/* {window.location.href.includes('admin/') ? */}
                        <div className='mb-3 col-sm-12 col-xs-12'>
                            <InputField
                                label="Community Expected Commission (Amount)"
                                variant="outlined"
                                value={communityExpectedCommision}
                                name="communityExpectedCommision"
                                id="communityExpectedCommision"
                                required={true}
                                type="number"
                                readOnly={disable}
                                onChange={e => inputChange(e, 'communityExpectedCommision')}
                                size="small" />
                            {/* <div id="commissionByUserHelp" className="form-text text-danger">{message.field === 'commissionByUserHelp' ? message.msg : ""}</div> */}
                        </div> 
                        {/* : ""} */}

                    <div className='col-sm-12 mt-4 col-xs-12 text-center' style={{marginTop:'15px'}}>
                        {
                            disable ?
                                <><button className="cred-btn" onClick={e => saveHandler('edit')}>Edit</button>
                                    <button className="cred-btn" style={{ backgroundColor: "gray" }}>Save</button></>
                                :
                                <><button className="cred-btn" style={{ backgroundColor: "gray" }}>Edit</button>
                                    <button className="cred-btn" onClick={e => saveHandler('save')}>Save</button></>
                        }

                    </div>
                </div>
                {
                    totalTime != 0 ?
                        <div className='mb-3 col-sm-6 col-xs-12 row text-center'>
                            <div className='col-sm-6 col-xs-12 text-center' style={{ marginTop: "35px" }}>
                                <p style={{ fontSize: '100px', fontFamily: 'digital-clock-font' }}><b>{totalTime - timeSpent}/{totalTime}</b></p>
                            </div>
                            <div className='col-sm-6 col-xs-12 text-center' style={{ marginTop: "145px" }}>
                                <p style={{ fontSize: '30px' }}>days Remaining</p>
                            </div>

                            <div className='col-sm-6 col-xs-12 text-right'>
                                {
                                    allData && allData.timerFlag == false ?
                                        <button style={{ color: "white" }} disabled className="cred-btn btn btn-disabled"><i className="fa fa-pause"></i>   Pause</button> :
                                        <button style={{ color: "white" }} onClick={(e)=> startOrStopTime(rowData.loanId, "stop")} className="cred-btn btn"><i className="fa fa-pause"></i>   Pause</button>
                                }

                            </div>
                            <div className='col-sm-6 col-xs-12 text-left'>

                                {
                                    allData && allData.timerFlag == true ?
                                        <button style={{ color: "white" }} disabled className="cred-btn btn btn-disabled"><i className="fa fa-play"></i>   Resume</button> :
                                        <button style={{ color: "white" }}  onClick={(e)=> startOrStopTime(rowData.loanId, "start")} className="cred-btn btn"><i className="fa fa-play"></i>   Resume</button>
                                }
                            </div>

                        </div> : ""
                }
            </div>

            {alertPopup ?
                <Alerts msg={msg} />
                : ""}
        </div>
    )

}
export default Commission


